import React, { useState } from 'react';
import { Box, Paper, Typography, TextField, Button, Avatar, CircularProgress } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store/reducers';
import { auth } from '../../store/actions/AuthAction';

const LockScreen: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const username =
        useSelector((state: RootState) => state.auth.username) ||
        localStorage.getItem('username') ||
        '';
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleUnlock = async () => {
        if (!password) {
            setError('Digite sua senha');
            return;
        }

        setLoading(true);
        setError('');

        try {
            // @ts-ignore
            dispatch(auth(username, password));

            // Small delay to let the auth action process
            setTimeout(() => {
                const tokenId = localStorage.getItem('token-id');
                if (tokenId) {
                    navigate('/');
                } else {
                    setError('Senha incorreta. Tente novamente.');
                    setLoading(false);
                }
            }, 2000);
        } catch (e) {
            setError('Erro ao desbloquear. Tente novamente.');
            setLoading(false);
        }
    };

    const handleLogout = () => {
        navigate('/sair');
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: '#f5f5f5',
                backgroundImage: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                position: 'relative',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backdropFilter: 'blur(8px)',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
            }}
        >
            <Paper
                elevation={6}
                sx={{
                    p: 4,
                    maxWidth: 400,
                    width: '100%',
                    textAlign: 'center',
                    position: 'relative',
                    zIndex: 1,
                    borderRadius: 3,
                }}
            >
                <Avatar
                    sx={{
                        width: 80,
                        height: 80,
                        mx: 'auto',
                        mb: 2,
                        bgcolor: '#1976d2',
                    }}
                >
                    <LockIcon sx={{ fontSize: 40 }} />
                </Avatar>

                <Typography variant="h6" gutterBottom>
                    {username}
                </Typography>

                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 3 }}
                >
                    Sessao bloqueada. Digite sua senha para continuar.
                </Typography>

                <TextField
                    fullWidth
                    type="password"
                    label="Senha"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleUnlock()}
                    sx={{ mb: 2 }}
                    error={!!error}
                    helperText={error}
                    disabled={loading}
                    autoFocus
                />

                <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    onClick={handleUnlock}
                    disabled={loading}
                    sx={{ mb: 1 }}
                >
                    {loading ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (
                        'Desbloquear'
                    )}
                </Button>

                <Button
                    fullWidth
                    color="inherit"
                    onClick={handleLogout}
                    disabled={loading}
                >
                    Sair
                </Button>
            </Paper>
        </Box>
    );
};

export default LockScreen;
